import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonDropdown from 'src/components/buttons/buttonDropdown/buttonDropdown';
import { DropdownItem } from 'reactstrap';
import Link from 'next/link';
import i18n from 'src/utils/translate';

class Navbar extends React.Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    customClick: PropTypes.func,
    isCompact: PropTypes.bool,
    selectedPage: PropTypes.string,
  }

  static defaultProps = {
    customClick: () => {},
    selectedPage: null,
    isCompact: false,
  }

  componentDidMount() {
    this.isMobile = document.documentElement.clientWidth < 768;
  }

  getExtraVisibleItemNumber = () => {
    return !this.props.isCompact ? 0 : 3;
  }

  renderLink = (item, itemClassName) => {
    if (item.as) {
      return (
        <React.Fragment>
          <Link
            as={item.isPostsLinkInCommunityHeader && this.isMobile ? `${item.as}#mobile` : item.as}
            href={item.link}
          >
            <a className={itemClassName}>
              {item.content}
            </a>
          </Link>
        </React.Fragment>
      );
    } else {
      return (
        <a
          className={itemClassName}
          href={item.link}
          onClick={(e) => this.props.customClick(item, e)}
        >
          {item.content}
        </a>
      );
    }
  }

  renderListItem = (item, i, blockClass) => {
    const extraVisibleItemNumber = this.getExtraVisibleItemNumber();
    const itemClassName = classNames({
      'active': this.props.selectedPage === item.id,
      'hidden-xxxs': i === 2 + extraVisibleItemNumber,
      'hidden-xxs': i === 3 + extraVisibleItemNumber,
      'hidden-xs': i >= 4 + extraVisibleItemNumber,
    });
    return (!item.mobileOnly &&
      <li className={`${blockClass}__list-item`} key={i}>
        <h2>{this.renderLink(item, itemClassName)}</h2>
      </li>
    );
  }

  renderDropdownItem = (item, i) => {
    const itemClassName = classNames({
      'visible-xxxs': i === 0,
      'visible-xxs': i === 1,
      'visible-xs': i > 1,
    });
    return (
      <DropdownItem
        className={itemClassName}
        key={i}
        onClick={() => {
          this.props.customClick(item);
          window.location.href = item.as || item.link;
        }}
      >
        {item.content}
      </DropdownItem>
    );
  }

  render() {
    const { items, isCompact } = this.props;
    const blockClass = 'navigation-bar';
    const className = classNames({
      'navigation-bar': true,
      'navigation-bar--compact': isCompact,
    });
    const extraVisibleItemNumber = this.getExtraVisibleItemNumber();
    const dropdownClassName = classNames({
      [`${blockClass}__more`]: true,
      'visible-xxxs': items.length === 3 + extraVisibleItemNumber,
      'visible-xxs': items.length === 4 + extraVisibleItemNumber,
      'visible-xs': items.length > 4 + extraVisibleItemNumber,
    });
    const minItems = 2 + extraVisibleItemNumber;

    return (
      <ul className={className}>
        {items.map((item, i) => this.renderListItem(item, i, blockClass))}
        {items.length > minItems &&
        <li className={dropdownClassName} >
          {items.length &&
          <ButtonDropdown
            className={`${blockClass}__more-btn-group`}
            color="none"
            text={i18n.t('More')}
          >
            {items.slice(minItems, items.length).map(this.renderDropdownItem)}
          </ButtonDropdown>}
        </li>}
      </ul>
    );
  }
}

export default Navbar;
